import React from 'react';
import { mailto, studioAddress } from '../content/site';

/**
 * A mail link whose address only exists once the page is running: the href is
 * attached on click, so the rendered HTML never carries the address.
 *
 * The one exception is `address`, used on the privacy policy. Google Play
 * requires a privacy point of contact that is readable in the page itself, so
 * there the address is printed and the href is real.
 */
function MailLink({
  subject = 'Hello AppNexa',
  body = '',
  className,
  address = false,
  children = 'Email the studio',
}) {
  const open = (event) => {
    event.preventDefault();
    window.location.href = mailto(subject, body);
  };

  if (address) {
    return (
      <a href={mailto(subject, body)} className={className}>
        {studioAddress()}
      </a>
    );
  }

  return (
    <a href="#contact" className={className} onClick={open} rel="nofollow">
      {children}
    </a>
  );
}

export default MailLink;
